export default {
  namespaced: true,

  state: {
    loading: false,
    loadingChild: false,
    avatarUrl: null,
    isMainMenuCollapsed: false,
    isTransactionMenuCollapse: false,
    isSignup: false,
    showHideCardColumn: null,
  },

  mutations: {
    // Unless it's an ajax request in vue template this can be accessed directly by
    // $store.commit('shared/SET_LOADING')
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LOADING_CHILD(state, payload) {
      state.loadingChild = payload;
    },
    SET_MAIN_MENU_COLLAPSE(state) {
      state.isMainMenuCollapsed = !state.isMainMenuCollapsed;
    },
    SET_AVATAR_URL(state, payload) {
      state.avatarUrl = payload;
    },
    SET_TRANSACTION_ONOFF(state) {
      state.isTransactionMenuCollapse = !state.isTransactionMenuCollapse;
    },
    SET_SIGNUP_ONOFF(state, payload) {
      state.isSignup = payload;
    },
    SET_TRANSACTION_OFF(state) {
      state.isTransactionMenuCollapse = true;
    },
    SHOW_HIDE_CARDS_COLUMN(state, payload) {
      state.showHideCardColumn = payload;
    },
  },

  // use `actions` for ajax request or to just follow vuex pattern
  actions: {
    setLoading({ commit }, payload) {
      commit('SET_LOADING', payload);
    },
    setMainMenuCollapse({ commit }) {
      commit('SET_MAIN_MENU_COLLAPSE');
    },
    // Special setting for My Transaction screen to keep always full screen mode
    setTransactionCollapseForMyTransactionScreen({ commit }) {
      commit('SET_TRANSACTION_OFF');
    },

    setTransactionCollapse({ commit }) {
      commit('SET_TRANSACTION_ONOFF');
    },
    setAvatarUrl({ commit }, payload) {
      commit('SET_AVATAR_URL', payload);
    },
    fnShowHideCardsColumn({ commit }, payload) {
      commit('SHOW_HIDE_CARDS_COLUMN', payload);
    },
  },

  getters: {
    loading: state => state.loading,
    loadingChild: state => state.loadingChild,
    avatarUrl: state => state.avatarUrl,
    isMainMenuCollapsed: state => state.isMainMenuCollapsed,
    isTransactionMenuCollapse: state => state.isTransactionMenuCollapse,
    isSignup: state => state.isSignup,
    showHideCardColumn: state => state.showHideCardColumn,
  },
};
